import React, { Fragment } from 'react';
import { Provider, Store } from 'react-redux';
import { Route } from 'react-router-dom';
import { ConnectedRouter } from 'react-router-redux';
import { history } from '../router';
import SVGDefs from '../../icons/svgdefs';
import { BreakpointSniffer } from '../layout/components';

import App from './App';

const Root = ({ store }: { store: Store }) => (
  <Provider store={store}>
    <Fragment>
      <SVGDefs />
      <BreakpointSniffer />
      <ConnectedRouter history={history}>
        <Route path="" component={App} />
      </ConnectedRouter>
    </Fragment>
  </Provider>
);

export default Root;



// WEBPACK FOOTER //
// ./src/modules/core/Root.js